import { render, staticRenderFns } from "./AdditionalAvailability.vue?vue&type=template&id=70d04d7a&"
import script from "./AdditionalAvailability.vue?vue&type=script&lang=js&"
export * from "./AdditionalAvailability.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalAvailability.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports